import { forwardRef } from "react";
import { Button, ButtonGroup as BsButtonGroup } from "react-bootstrap";
import { KeyValue } from "../../../models/key-value";
import styles from "./ButtonGroup.module.css";

export type ButtonGroupProps = {
  value?: string | null;
  items?: KeyValue<string>[];
  disabled?: boolean;
  onChange?: (event: any) => void;
};

const ButtonGroup = forwardRef(
  ({ value, items, onChange }: ButtonGroupProps, ref) => {
    const btnClickHandler = (clickedId: string) => {
      if (onChange) {
        onChange(clickedId);
      }
    };

    return (
      <BsButtonGroup className={`${styles.group} form-control-sm p-0`}>
        {items?.map((item, i) => (
          <Button
            key={item.key}
            className={`${styles.button}  ${
              item.key === value ? `${styles.active}` : ""
            } p-1 font-sm btn-sm `}
            variant=""
            onClick={() => btnClickHandler(item.key)}
          >
            {item.value}
          </Button>
        ))}
      </BsButtonGroup>
    );
  }
);

export default ButtonGroup;
